import { render, staticRenderFns } from "./SendUsMessage.vue?vue&type=template&id=0a317590&scoped=true&"
import script from "./SendUsMessage.vue?vue&type=script&lang=js&"
export * from "./SendUsMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendUsMessage.vue?vue&type=style&index=0&id=0a317590&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a317590",
  null
  
)

export default component.exports